<template>
  <FeatureBanner
    v-element-visibility="[
      (visible: boolean) => visible && onDataTrackingEvent('view'),
      { threshold: 1 },
    ]"
    v-bind="props"
    @click="onFeatureBannerClick"
  />
</template>

<script lang="ts" setup>
import FeatureBanner from '@sephora-asia/ui-feature-banner'
import type { FeatureBannerContainerProps } from '~/types/components/contentful/components.types'
import { vElementVisibility } from '@vueuse/components'

const props = defineProps<FeatureBannerContainerProps>()

const { trackEvent } = useGtmTrack()

const pageMetaStore = usePageMetaStore()

function onFeatureBannerClick() {
  onDataTrackingEvent('click')
}

function onDataTrackingEvent(event: string) {
  trackEvent({
    event: `${pageMetaStore.pageType}_feature_banner_${event}`,
    params: {
      banner_name: props.internalName,
      content_banner_position: props.componentPosition,
      page_path: useRoute().path,
      segmented: props.isSegmented,
      segments: props.segments?.join(','),
    },
  })
}
</script>
